export default `
<div class="vue-app" :style="{ ...elementsHeight, pointerEvents: appIsReady ? 'auto' : 'none' }" :class="{loading: apiLoading}">

    <div class="search-results-header map-closed">


        
        <div class="search-results-header__top--filter-search">
        <!-- Filter search -->
        <div class="container">
                <div class="search-results-header__top-inner">
                    <div class="search-results-header__form-wrapper">
                        <div class="search-results-header__form">
                            <form class="search-form" :class="{active: searchInput}"  ref="searchForm" @submit.prevent="searchSubmit">
                                <input 
                                    autocomplete="off"
                                    type="text" 
                                    name="search" 
                                    required 
                                    :placeholder="searchPlaceholder"
                                    ref="searchInput"
                                    v-model="searchInput"
                                    @input="searchInputHandler"
                                    @keydown="handleEnterKey"
                                >
                                <button type="submit" class="search-form__submit" title="Search" aria-label="Search">
                                <i class="search-icon--map"></i>
                                </button>
                                <span 
                                class="search-form__clear"
                                :class="{ 'active': searchInput && searchInput.length > 0 }"
                                v-if="searchInput && searchInput.length > 0 && searchInput.toLowerCase() !== 'united kingdom'"
                                @click="resetAll"
                            >
                                <i class="icon-close icon-close--purple"></i>
                            </span>
                            </form>
                        </div>
                        
                        <!-- Filters button -->
                        <div class="search-results-header__filter-btn" 
                        >
                            <button
                                class="white button--map-filters"
                                @click="toggleFilter"
                            >
                                <i class="icon-filter"></i> Filters <span v-if="filtersNum > 0">({{ filtersNum }})</span>
                            </button>
                        </div>

                    </div>
                    
                </div> <!-- Container -->
        </div> 
        </div> 
        <div class="search-results-header__top">
        <div class="search-form-section--bg">
            <!--      Title      -->
            <div class="container">
                <div>
                    <p class="search-results-header__results-quantity body-copy-light"
                        v-if="!selectedHiddenMarker"
                        v-html="resultsText"
                    >                
                    </p>
                </div>
            </div>
        </div>
        
        <!-- City buttons | No longer wanted by client -->
        <!--            <div class="container">-->
        <!--                <div class="city-buttons">-->
        <!--                    <template v-for="city in cities">-->
        <!--                        <button -->
        <!--                        @click="selectCity(city)" -->
        <!--                        class="button city"-->
        <!--                        :class="{ 'selected': selectedCity === city }"-->
        <!--                        data-no-hover-on-touch-->
        <!--                        >-->
        <!--                            <span class="button__text">{{ city }}</span>-->
        <!--                        </button>      -->
        <!--                    </template>-->
        <!--                </div>-->
        <!--            </div>-->
        
    </div>
        <!-- Moved to title section
        <div class="container">
            <div class="search-results-header__info-nav-panel" :class="{ disabled: filterOpened }">
                <p class="search-results-header__results-quantity body-copy-light"
                    v-if="!selectedHiddenMarker"
                    v-html="resultsText"
                >
                </p>
                -->
                
                <!-- Removed sort
                <button 
                    class="
                        search-results-header__results-quantity 
                        search-results-header__results-quantity--btn 
                        body-copy-light"
                    v-else
                    @click="backToFilteredResults"
                >
                    Back to search results
                </button>
                <div class="search-results-header__map-trigger">
                    <button 
                        class="button-trigger" 
                        :class="{active: mapOpened}"
                        @click="mapOpened = !mapOpened"
                    >
                        Map
                    </button>

                    <label class="default-input">
                        <select  name="Sort by"  @change="onChangeSortOrder($event)">
                            <option selected="" value="">Sort by</option>
                            <option value="asc">Price Asc</option>
                            <option value="desc">Price Desc</option>
                        </select>
                    </label>
                </div>
                -->
                
            <!-- Moved to title section
            </div>
        </div>
        -->
        
    </div>
    <div class="search-results-buildings" :class="{ 'map-closed': !mapOpened }">
        <div 
            class="search-results-buildings__overlay"
            :class="{ active: filterOpened }"
            @click="filterOpened = false"
        >    
        </div>
        <div class="container">
            <div 
                class="search-results-buildings__inner"
                :class="{ 'full-width': !mapOpened }"
            >
                <ul class="search-results-buildings__items">
                    <li 
                        class="search-results-buildings__item"
                        v-for="marker in markersResultList"
                        :class="{ hovered: hoveredBuilding === marker.id, active: activeBuilding === marker.id }"
                        ref="buildings"
                        :id="'id_' + marker.id"
                        :key="marker.id"
                        @mouseover="hoveredBuilding = marker.id"
                        @mouseout="hoveredBuilding = -1"
                    >
                        <div 
                            class="search-results-buildings__item-inner"
                            :class="{ 'highlight': marker.highlight }"
                        >
                            <a :href="marker.link">
                                <p 
                                    class="search-results-buildings__item-status-desk body-copy-black" 
                                    v-if="marker.status"
                                    v-html="marker.status"
                                >
                                    {{marker.status}}
                                </p>
                                <img 
                                    class="search-results-buildings__item-image" 
                                    :src="marker.image" 
                                    :alt="marker.name"
                                >
                            </a>
                            <div 
                                class="search-results-buildings__item-header" 
                                :class="{ 'highlight': marker.highlight }"
                            >
                                <a :href="marker.link">
                                    <div class="search-results-buildings__item-top">
                                        <p class="search-results-buildings__item-name">
                                            {{marker.name}}
                                        </p>
                                    </div>
                                    <p class="search-results-buildings__item-address">
                                    <i
                                    :class="[
                                      'icon-pin',
                                      {
                                        'icon-pin-white': hoveredBuilding === marker.id || activeBuilding === marker.id,
                                        'icon-pin-black': hoveredBuilding !== marker.id && activeBuilding !== marker.id
                                      }
                                    ]"
                                  ></i>
                                        {{marker.address}}
                                    </p>
                                    <!-- distance debug
                                    <p class="search-results-buildings__item-address"
                                    >
                                        {{ marker.distance }}
                                    </p>
                                    -->
                                    <!-- Not needed anymore
                                    <p class="search-results-buildings__item-status-mob body-copy-black">
                                        {{marker.status}}
                                    </p>
                                    -->
                                    <ul class="search-results-buildings__transports body-copy-light">
                                        <li class="search-results-buildings__transport">
                                            <template v-for="(item, index) in marker.transport">
                                            <template v-if="item.type && item.name && item.walking && index === 0">
                                                <i :class="'transport-icon-' + item.type"></i>
                                                <span class="building-transport__item-text d-flex align-items-center">
                                                {{ item.name }} 
                                                <i
                                                    :class="[
                                                    'icon-walking',
                                                    {
                                                        'icon-walking-white': hoveredBuilding === marker.id || activeBuilding === marker.id,
                                                        'icon-walking-black': hoveredBuilding !== marker.id && activeBuilding !== marker.id
                                                    }
                                                    ]"
                                                ></i>
                                                {{ item.walking }}
                                                </span>
                                            </template>
                                            </template>
                                        </li>
                                    </ul>
                                    <template>
                                    <ul class="search-results-buildings__products body-copy-light">
                                      <li 
                                        :class="[
                                          'search-results-buildings__product',
                                          hoveredBuilding === marker.id || activeBuilding === marker.id ? 'white active' : ''
                                        ]"
                                        v-for="(value, name) in marker.products"
                                        v-if="name"
                                        :key="name"
                                      >
                                          {{ name }}
                                        <!-- <div class="search-results-buildings__product-cost">{{value}}</div> -->
                                      </li>
                                    </ul>
                                  </template>
                                  
                                </a>

                                <div class="search-results-buildings__footer">
                                    <div class="search-results-buildings__footer-btn view-details">
                                        <a 
                                            class="button button--building-view" 
                                            :href="marker.link"
                                            target="_self"
                                        >
                                            <span class="button__text">
                                                View Details
                                            </span>
                                        </a>
                                    </div>
                                    <div class="search-results-buildings__footer-btn">
                                        <button 
                                            @click="showEnquieries(marker)"
                                            class="button"
                                        >
                                            <span class="button__text">Enquire Now</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                      
                     
                            
                            
                            <!-- removed transport info
                            <h4 class="search-results-buildings__transport-title body-copy-black">
                                Nearest Connections
                            </h4>
                            <ul class="search-results-buildings__transports body-copy-light">
                                <li class="search-results-buildings__transport" v-for="item in marker.transport">
                                    <i :class="{ 
                                        'transport-icon-rail': item.type === 'rail', 
                                        'transport-icon-tube': item.type === 'tube',
                                        'transport-icon-road': item.type === 'road',
                                    }">      
                                    </i>
                                    {{item.name}}
                                </li>
                            </ul>
                            -->
                            
                            <!--
                            <div class="search-results-buildings__footer">
                                <div class="search-results-buildings__footer-btn">
                                    <a class="button button--building-view" :href="marker.link">
                                        <span class="button__text">View Details</span>
                                    </a>
                                </div>
                                <div class="search-results-buildings__footer-btn">
                                    <button 
                                        @click="openEnquiresPopup()" 
                                        class="button button--building-enquire"
                                    >
                                        <span class="button__text">Get a Quote</span>
                                    </button>
                                </div>
                            </div>
                            -->
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    
    <!-- Google map -->
    <div class="search-results-map" :class="{'active': mapOpened}">
        <div class="search-results-map__map" ref="map"></div>
        <div v-if="mobileInfoWindowOpened" class="search-results-map__mobile_info-window" v-html="mobileInfoWindowHtml"></div>

        <div class="search-results-map__find-me-controls" ref="mapControls">
            <button
                class="find-me"
                title="Find Me"
                ref="mapControlFindMe"
                data-no-hover-on-touch
                @click="findMe"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <g clip-path="url(#clip0_56_373)">
            <path d="M17.226 8.226H15.354C15.048 5.274 12.726 3.114 9.774 2.628V0.774001C9.774 0.568723 9.69245 0.371853 9.5473 0.2267C9.40215 0.0815472 9.20528 7.7486e-07 9 7.7486e-07C8.79472 7.7486e-07 8.59785 0.0815472 8.4527 0.2267C8.30755 0.371853 8.226 0.568723 8.226 0.774001V2.646C6.81491 2.84548 5.50656 3.49714 4.49723 4.50323C3.4879 5.50931 2.83202 6.81556 2.628 8.226H0.774C0.568722 8.226 0.371852 8.30755 0.226699 8.4527C0.0815462 8.59785 0 8.79472 0 9C0 9.20528 0.0815462 9.40215 0.226699 9.5473C0.371852 9.69245 0.568722 9.774 0.774 9.774H2.646C3.096 12.726 5.274 15.048 8.226 15.372V17.226C8.226 17.4313 8.30755 17.6281 8.4527 17.7733C8.59785 17.9185 8.79472 18 9 18C9.20528 18 9.40215 17.9185 9.5473 17.7733C9.69245 17.6281 9.774 17.4313 9.774 17.226V15.354C12.726 15.048 14.904 12.726 15.372 9.774H17.226C17.4313 9.774 17.6281 9.69245 17.7733 9.5473C17.9185 9.40215 18 9.20528 18 9C18 8.79472 17.9185 8.59785 17.7733 8.4527C17.6281 8.30755 17.4313 8.226 17.226 8.226ZM13.806 8.226H9.774V4.194C10.7798 4.36832 11.7071 4.84931 12.4289 5.57111C13.1507 6.29291 13.6317 7.22021 13.806 8.226ZM8.226 4.194V8.226H4.194C4.36831 7.22021 4.84931 6.29291 5.57111 5.57111C6.29291 4.84931 7.22021 4.36832 8.226 4.194ZM4.194 9.774H8.226V13.806C7.22021 13.6317 6.29291 13.1507 5.57111 12.4289C4.84931 11.7071 4.36831 10.7798 4.194 9.774ZM9.774 13.806V9.774H13.806C13.6317 10.7798 13.1507 11.7071 12.4289 12.4289C11.7071 13.1507 10.7798 13.6317 9.774 13.806Z" fill="#445159"/>
            </g>
            <defs>
            <clipPath id="clip0_56_373">
            <rect width="18" height="18" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            </button>
        </div>
        <div class="search-results-map__zoom-controls" ref="mapControls">
            <button 
                class="zoom-in" 
                title="Zoom In" 
                ref="mapControlIn" 
                data-no-hover-on-touch 
                @click="applyZoom('add', '1')"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21">
                    <path 
                        fill="none" 
                        fill-rule="evenodd" 
                        stroke="#1F1D41" 
                        stroke-linecap="square" 
                        d="M1 10.5h18.816M10.5 1v18.816"
                    />
                </svg>
            </button>
            <button 
                class="zoom-out" 
                title="Zoom Out" 
                ref="mapControlOut" 
                data-no-hover-on-touch 
                @click="applyZoom('minus', 1)"    
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="1">
                    <path 
                        fill="none" 
                        fill-rule="evenodd" 
                        stroke="#1F1D41" 
                        stroke-linecap="square" 
                        d="M1 .5h18.816"
                    />
                </svg>
            </button>
        </div>
    </div>
    
    
    <!-- Mobile -->
    <div class="search-results-map-toggle-mobile" :class="{ 'list-mode': !mapOpened }">
        <button @click="mapOpened = !mapOpened" class="button-map-toggle-mobile">
            <svg v-if="mapOpened" xmlns="http://www.w3.org/2000/svg" width="15" height="10">
                <path 
                    fill="none" 
                    fill-rule="evenodd" 
                    stroke="#fff" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    d="M5 .6h8.662M5 4.6h8.662M5 8.6h8.662M2 .6h-.962M2 4.6h-.962M2 8.6h-.962"
                />
            </svg>
            <svg 
                v-else 
                xmlns="http://www.w3.org/2000/svg" 
                width="14" 
                height="19"
            >
                <path 
                    fill="#fff" 
                    fill-rule="evenodd" 
                    stroke="#fff" 
                    stroke-width=".5" 
                    d="M7 8.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 7 8.5m0-3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M1.75 6.702C1.75 4.064 4.203 1.75 7 1.75s5.25 2.314 5.25 4.952c0 2.59-1.922 5.657-5.25 10.895C3.633 12.292 1.75 9.293 1.75 6.7M7 1C3.852 1 1 3.552 1 6.702 1 9.85 3.602 13.608 7 19c3.398-5.391 6-9.15 6-12.299C13 3.552 10.15 1 7 1"/>
            </svg>
            <span>{{ mapOpened ? 'List' : 'Map' }} view</span>
        </button>
    </div>
  
    
    <div class="search-results-filter-mobile" :class="{opened: filterOpened}">
                                    <button
                                        class="search-results-filter__close"
                                        @click="toggleFilter"
                                        title="Close filters"
                                        aria-label="Close filters"
                                    >
                                        <i class="icon-close icon-close--purple"></i>
                                    </button>
        <div class="container" style="padding:0px 10px;">
            <h4 class="search-results-filter__title">Search Filters</h4>
            <h3 class="body-copy-black filter--label">Space type</h3>
            <p class="body-copy-light filter--description d-none">Select the type of space you need</p>
            <ul class="search-results-filter__options search-results-filter__options--office-type">
                <li v-for="(value, key) in selectedFilters">
                    <button
                        :class="{ selected: selectedFilters[key] }"
                        @click="toggleFilterOption(key)"
                        :key="key"
                    >
                    <i :class="['icon-office-type icon-office-type-' + santizieStringToUrlApproprite(key)]"></i>
                    <p>{{key}}</p>
                    </button>
                </li>
            </ul>
            <!-- Capacity -->
            <h3 class="body-copy-black filter--label">Meeting room capacity</h3>
            <ul class="search-results-filter__options search-results-filter__options--capacity" :class="{ 'disabled': !capacityAvailable }">
                <li v-for="key in capacityFilters" :key="key">
                <button
                    :class="{ selected: selectedCapacityFilters[key] }"
                    @click="toggleFilterCapacityOption(key)"
                    :disabled="!capacityAvailable"
                >
                    {{ key }}
                </button>
                </li>
             </ul>
            
            <!-- Amenities Mobile !-->
            <h3 class="body-copy-black filter--label">Building amenities</h3>
            <ul class="search-results-filter__options">
                <li v-for="key in displayedAmenitiesFilters" :key="key">
                    <button
                        style=""
                        :class="{ 
                            selected: selectedAmenitiesFilters[key], 
                            square:'square', 
                        }"
                        @click="toggleFilterAmenitiesOption(key)"
                    >
                        {{ key }}
                    </button>
                </li>
            </ul>
            <button @click="toggleShowAllAmenities" class="show-more-amenities" :class="{ 'active': isAllAmenitiesShown }">
                {{ isAllAmenitiesShown ? 'Show less' : 'Show more' }}
            </button>
            
            <!-- 
            <h3 class="body-copy-black">Team Size</h3>
            <div class="search-results-filter__team-block">
                <div class="default-form__input pull-left" >
                    <label class="default-input">
                        <select name="Minimum team size">
                            <option selected="" value="">Minimum team size</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10+</option>
                        </select>
                    </label>
                </div>
                <div class="default-form__input pull-right">
                    <label class="default-input">
                        <select name="team">
                            <option selected="" value="">Maximum team size</option>
                            <option value="20">20+</option>
                            <option value="30">30+</option>
                            <option value="40">40+</option>
                            <option value="50">50+</option>
                            <option value="60">60+</option>
                            <option value="70">70+</option>
                            <option value="80">80+</option>
                            <option value="90">90+</option>
                            <option value="100">100+</option>
                        </select>
                    </label>
                </div>
            </div>
           -->

            <div class="search-results-filter__footer">	
                <div class="search-results-filter__clear">
                    <button
                        class="button-text"
                        @click="clearFilters()"
                    >
                        <span class="button__text">Clear filters</span>
                    </button>
                </div>

                <div class="search-results-filter__apply">
                    <button 
                        @click="filterLocations()" 
                        class="button--map-filter"
                    >
                        <span class="button__text">Show locations</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div 
        class="search-results-filter-mobile-overlay"
        @click="toggleFilter"
        :class="{visible: filterOpened}"
    >
    </div>
    <div class="search-results-buildings-mobile" :class="{ opened: mobileListOpened }">
        <div class="container">
            <div class="search-results-buildings-mobile__inner">
                <div class="popup-close-wrapper">
                    <button 
                        class="popup-close-wrapper__close-button"
                        @click="mobileListOpened = false"
                    >
                        <svg 
                            class="popup-close-wrapper__close-icon" 
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 34 34" 
                            width="34" 
                            height="34"
                        >
                            <circle 
                                cx="17" 
                                cy="17" 
                                r="16.5" 
                                fill="#FFF" 
                                fill-rule="evenodd" 
                                stroke="#E3E3E3" 
                                clip-rule="evenodd"
                            >
                            </circle>
                            <path 
                                fill="none" 
                                stroke="#1F1D41" 
                                stroke-linecap="square" 
                                d="M12.464 12.56l9.829 9.828M22.364 12.56l-9.83 9.828">
                            </path>
                        </svg>
                    </button>
                </div>
                <p 
                    class="search-results-buildings-mobile__title body-copy-light"
                    v-if="!selectedHiddenMarker"
                    v-html="resultsText"
                >
                </p>
                <button 
                    class="
                        search-results-buildings-mobile__title 
                        search-results-buildings-mobile__title--btn 
                        body-copy-light"
                    v-else
                    @click="backToFilteredResults"
                >
                    Back to search results
                </button>

                <div class="search-results-buildings-mobile__slider">
                    <div class="swiper-container" ref="buildingsListMobile">
                        <div class="swiper-wrapper">
                            <div 
                                class="swiper-slide"
                                v-for="marker in markersResultList"
                                :data-id="marker.id"
                                :key="marker.id"
                            >
                                <div 
                                    class="search-results-buildings-mobile__slide"
                                    :class="{
                                        hovered: hoveredBuilding === marker.id,
                                        active: activeBuilding === marker.id,
                                    }"
                                    @click="mobileListClick(marker.id)"
                                >
                                    <div class="search-results-buildings-mobile__image">
                                        <img 
                                            class="search-results-buildings__item-image" 
                                            :src="marker.image" 
                                            :alt="marker.name"
                                        >
                                    </div>
                                    <h3 class="search-results-buildings-mobile__name">{{marker.name}}</h3>
                                    <p class="search-results-buildings-mobile__address">{{marker.address}}</p>
                                    <p class="search-results-buildings-mobile__status">{{marker.status}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;
